import * as R from 'ramda';
// helpers/constants
import * as G from '../../../../../helpers';
// feature template-inspection
import * as C from '../../constants';
import BoxTruck1AxleTop from '../assets/box-truck-axle-top';
import BoxTruck1AxleBack from '../assets/box-truck-axle-back';
import BoxTruck1AxleFront from '../assets/box-truck-axle-front';
import BoxTruck1AxleSide from '../assets/box-truck-1-axle-side';
import BoxTruck2AxleSide from '../assets/box-truck-2-axle-side';
//////////////////////////////////////////////////

const BTACT = R.prop('boxTruckAxleComponentTypes', C);

// Box Truck Axle Front
const boxTruckAxleFrontConfig = {
  flipImage: false,
  image: BoxTruck1AxleFront,
  size: [422, 496],
  marker: null,
  vehicleComponentTypes: {
    [BTACT.ODOMETER_WITH_DASHBOARD]: {
      position: ['65%', '40%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-odometer-with-dashboard',
        'Odometer with dashboard'),
    },
    [BTACT.TRANSPONDER]: {
      position: ['57%', '30%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-transponder',
        'Transponder'),
    },
    [BTACT.TABLET_NUMBER]: {
      position: ['46%', '42%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-tablet-number',
        'Tablet number'),
    },
    [BTACT.WINDSHIELD]: {
      position: ['45%', '34%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-windshield',
        'Windshield'),
    },
    [BTACT.DRIVER_WINDSHIELD]: {
      position: ['72%', '34%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-driver-side-windshield',
        'Driver side windshield'),
    },
    [BTACT.PASSENGER_WINDSHIELD]: {
      position: ['22%', '34%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-passenger-side-windshield',
        'Passenger side windshield'),
    },
    [BTACT.OUTSIDE_FRONT_WITH_LIGHTS_ON]: {
      position: ['45.75%', '62%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-outside-front-with-lights-on',
        'Outside front with lights on'),
    },
  },
};

// Box Truck Axle Back
const boxTruckAxleBackConfig = {
  flipImage: false,
  image: BoxTruck1AxleBack,
  size: [422, 490],
  marker: null,
  vehicleComponentTypes: {
    [BTACT.OUTSIDE_BACK_WITH_LIGHTS_ON]: {
      position: ['47%', '33%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-outside-back-with-lights-on',
        'Outside back with lights on'),
    },
  },
};

// Box Truck Axle Top
const boxTruckAxleTopConfig = {
  flipImage: false,
  image: BoxTruck1AxleTop,
  size: [255, 685.5],
  marker: null,
  vehicleComponentTypes: {
    [BTACT.TRIANGLES]: {
      position: ['23%', '22.5%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-triangles',
        'Triangles'),
    },
    [BTACT.FIRE_EXTINGUISHER]: {
      position: ['23%', '28%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-fire-extinguisher',
        'Fire extinguisher'),
    },
    [BTACT.ENGINE_WITH_COOLANT_LEVEL]: {
      position: ['28%', '8.5%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-engine-with-coolant-level',
        'Engine with coolant level'),
    },
    [BTACT.OIL_LEVEL]: {
      position: ['14%', '8.5%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-oil-level',
        'Oil level'),
    },
    [BTACT.INSIDE_BOX_RARE]: {
      position: ['43%', '68%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-inside-box-rare',
        'Inside box rare'),
    },
    [BTACT.CHAINS]: {
      position: ['43%', '38%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-chains',
        'Chains'),
    },
  },
};

// Box Truck 1 Axle Left
const boxTruck1AxleLeftConfig = {
  left: -5,
  marker: null,
  flipImage: false,
  size: [680, 294],
  image: BoxTruck1AxleSide,
  vehicleComponentTypes: {
    [BTACT.OUTSIDE_DRIVER_SIDE_WITH_LIGHTS_ON]: {
      position: ['65%', '30%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-outside-driver-side-with-lights-on',
        'Outside driver side with lights on'),
    },
    [BTACT.FRONT_DRIVER_SIDE_TIRES]: {
      position: ['11%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-front-driver-side-tire',
        'Front driver side tire'),
    },
    [BTACT.REAR_DRIVER_SIDE_TIRES]: {
      position: ['70%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-rear-driver-side-tire',
        'Rear driver side tire'),
    },
  },
};

// Box Truck 1 Axle Right
const boxTruck1AxleRightConfig = {
  left: -5,
  marker: null,
  flipImage: true,
  size: [680, 294],
  image: BoxTruck1AxleSide,
  vehicleComponentTypes: {
    [BTACT.OUTSIDE_PASSENGER_SIDE_WITH_LIGHTS_ON]: {
      position: ['65%', '30%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-outside-passenger-side-with-lights-on',
        'Outside passenger side with lights on'),
    },
    [BTACT.FRONT_PASSENGER_SIDE_TIRES]: {
      position: ['10.25%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-front-passenger-side-tire',
        'Front passenger side tire'),
    },
    [BTACT.REAR_PASSENGER_SIDE_TIRES]: {
      position: ['69.75%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-rear-passenger-side-tire',
        'Rear passenger side tire'),
    },
  },
};

// Box Truck 2 Axle Left
const boxTruck2AxleLeftConfig = {
  left: -5,
  marker: null,
  flipImage: false,
  size: [748, 294],
  image: BoxTruck2AxleSide,
  vehicleComponentTypes: {
    [BTACT.OUTSIDE_DRIVER_SIDE_WITH_LIGHTS_ON]: {
      position: ['65%', '30%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-outside-driver-side-with-lights-on',
        'Outside driver side with lights on'),
    },
    [BTACT.FRONT_DRIVER_SIDE_TIRES]: {
      position: ['10%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-front-driver-side-tire',
        'Front driver side tire'),
    },
    [BTACT.REAR_DRIVER_SIDE_INNER_TIRES]: {
      position: ['68.5%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-rear-driver-side-inner-tire',
        'Rear driver side inner tire'),
    },
    [BTACT.REAR_DRIVER_SIDE_OUTER_TIRES]: {
      position: ['80.75%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-rear-driver-side-outer-tire',
        'Rear driver side outer tire'),
    },
  },
};

// Box Truck 2 Axle Right
const boxTruck2AxleRightConfig = {
  left: -5,
  marker: null,
  flipImage: true,
  size: [748, 294],
  image: BoxTruck2AxleSide,
  vehicleComponentTypes: {
    [BTACT.OUTSIDE_PASSENGER_SIDE_WITH_LIGHTS_ON]: {
      position: ['65%', '30%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-outside-passenger-side-with-lights-on',
        'Outside passenger side with lights on'),
    },
    [BTACT.FRONT_PASSENGER_SIDE_TIRES]: {
      position: ['10%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-front-passenger-side-tire',
        'Front passenger side tire'),
    },
    [BTACT.REAR_PASSENGER_SIDE_INNER_TIRES]: {
      position: ['68.25%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-rear-passenger-side-inner-tire',
        'Rear passenger side inner tire'),
    },
    [BTACT.REAR_PASSENGER_SIDE_OUTER_TIRES]: {
      position: ['80.5%', '92%'],
      name: G.getWindowLocale(
        'titles:inspection-component-type-rear-passenger-side-outer-tire',
        'Rear passenger side outer tire'),
    },
  },
};

const boxTruck1AxleSectionConfig = {
  [C.INSPECTION_BOX_TRUCK_1_AXLE_TOP]: boxTruckAxleTopConfig,
  [C.INSPECTION_BOX_TRUCK_1_AXLE_BACK]: boxTruckAxleBackConfig,
  [C.INSPECTION_BOX_TRUCK_1_AXLE_LEFT]: boxTruck1AxleLeftConfig,
  [C.INSPECTION_BOX_TRUCK_1_AXLE_FRONT]: boxTruckAxleFrontConfig,
  [C.INSPECTION_BOX_TRUCK_1_AXLE_RIGHT]: boxTruck1AxleRightConfig,
};

const boxTruck2AxleSectionConfig = {
  [C.INSPECTION_BOX_TRUCK_2_AXLE_TOP]: boxTruckAxleTopConfig,
  [C.INSPECTION_BOX_TRUCK_2_AXLE_BACK]: boxTruckAxleBackConfig,
  [C.INSPECTION_BOX_TRUCK_2_AXLE_LEFT]: boxTruck2AxleLeftConfig,
  [C.INSPECTION_BOX_TRUCK_2_AXLE_FRONT]: boxTruckAxleFrontConfig,
  [C.INSPECTION_BOX_TRUCK_2_AXLE_RIGHT]: boxTruck2AxleRightConfig,
};

export {
  boxTruck1AxleSectionConfig,
  boxTruck2AxleSectionConfig,
};
